import {
    LayoutDashboard, Mountain, Factory, Wrench, Boxes, ShieldCheck, Leaf, Waves,
    Droplets, Shield, Warehouse, ShoppingCart, HardHat, BookOpen, FileText,
    Cpu, Sparkles, Landmark, Bot, DollarSign, Beaker, TrendingUp, ScrollText,
    Radar, ShieldAlert, Compass, TestTube, Ruler, ClipboardList, Truck,
    Users, Gauge, AlertOctagon, Scale, Zap, Film, Clapperboard,
} from "lucide-react";

export const MODULE_GROUPS = [
    {
        family: "executive",
        label: "Executive Intelligence",
        accent: "purple",
        items: [
            { id: "executive", label: "Executive Command Centre", path: "/", icon: LayoutDashboard, testid: "nav-executive" },
            { id: "ai", label: "AI Advisor · 13 agents", path: "/ai", icon: Bot, testid: "nav-ai" },
            { id: "twin", label: "Digital Twin 2.0", path: "/twin", icon: Cpu, testid: "nav-twin" },
            { id: "reports", label: "Executive Reporting", path: "/reports", icon: ScrollText, testid: "nav-reports" },
            { id: "board", label: "Board Portal", path: "/board", icon: Landmark, testid: "nav-board" },
            { id: "briefing", label: "Executive Daily Briefing", path: "/briefing", icon: Sparkles, testid: "nav-briefing" },
            { id: "storylines", label: "Storyline Engine", path: "/storylines", icon: Clapperboard, testid: "nav-storylines" },
            { id: "presentation", label: "Presentation Mode", path: "/presentation", icon: Film, testid: "nav-presentation" },
            { id: "scenarios", label: "Scenario Planning", path: "/scenarios", icon: TrendingUp, testid: "nav-scenarios" },
            { id: "capital", label: "Capital Portfolio", path: "/capital-portfolio", icon: DollarSign, testid: "nav-capital" },
            { id: "decisions", label: "Decision Register", path: "/decisions", icon: Gauge, testid: "nav-decisions" },
            { id: "strategy", label: "Strategy & Decisions", path: "/strategy", icon: ClipboardList, testid: "nav-strategy" },
            { id: "value", label: "Value Realisation", path: "/value", icon: TrendingUp, testid: "nav-value" },
            { id: "minelife", label: "Mine Life Intelligence", path: "/mine-life", icon: Compass, testid: "nav-minelife" },
            { id: "integrations", label: "Integration Hub", path: "/integrations", icon: Cpu, testid: "nav-integrations" },
        ],
    },
    {
        family: "operations",
        label: "Operations & Reliability",
        accent: "copper",
        items: [
            { id: "mining", label: "Mining360", path: "/mining", icon: Mountain, testid: "nav-mining" },
            { id: "mine-int", label: "Mine Ops Intelligence", path: "/mine-intelligence", icon: TrendingUp, testid: "nav-mine-intelligence" },
            { id: "mts", label: "Mine Technical Services360", path: "/mts", icon: Compass, testid: "nav-mts" },
            { id: "plant", label: "Plant360", path: "/plant", icon: Factory, testid: "nav-plant" },
            { id: "metallurgy", label: "Metallurgical Accounting", path: "/metallurgy", icon: Beaker, testid: "nav-metallurgy" },
            { id: "laboratory", label: "Laboratory360", path: "/laboratory", icon: TestTube, testid: "nav-laboratory" },
            { id: "engineering", label: "Engineering360", path: "/engineering", icon: Ruler, testid: "nav-engineering" },
            { id: "maintenance", label: "Maintenance360", path: "/maintenance", icon: Wrench, testid: "nav-maintenance" },
            { id: "refinery-maint", label: "Refinery Maintenance Mgr360", path: "/refinery-maintenance", icon: Wrench, testid: "nav-refinery-maintenance" },
            { id: "predictive", label: "Predictive Analytics", path: "/predictive", icon: Radar, testid: "nav-predictive" },
            { id: "assets", label: "Asset360", path: "/assets", icon: Boxes, testid: "nav-assets" },
        ],
    },
    {
        family: "hse",
        label: "HSE, ESG & Security",
        accent: "green",
        items: [
            { id: "safety", label: "Safety360", path: "/safety", icon: ShieldCheck, testid: "nav-safety" },
            { id: "environment", label: "Environment360", path: "/environment", icon: Leaf, testid: "nav-environment" },
            { id: "tailings", label: "Tailings360", path: "/tailings", icon: Waves, testid: "nav-tailings" },
            { id: "water", label: "Water360", path: "/water", icon: Droplets, testid: "nav-water" },
            { id: "energy", label: "Energy360", path: "/energy", icon: Zap, testid: "nav-energy" },
            { id: "esg", label: "ESG360", path: "/esg", icon: Leaf, testid: "nav-esg" },
            { id: "community", label: "Community360", path: "/community", icon: Users, testid: "nav-community" },
            { id: "security", label: "Security360", path: "/security", icon: Shield, testid: "nav-security" },
            { id: "cyber", label: "Cyber SOC", path: "/cyber", icon: ShieldAlert, testid: "nav-cyber" },
        ],
    },
    {
        family: "finance",
        label: "Finance, Supply & Projects",
        accent: "cobalt",
        items: [
            { id: "finance", label: "Finance360", path: "/finance", icon: DollarSign, testid: "nav-finance" },
            { id: "projects", label: "Projects360", path: "/projects", icon: ClipboardList, testid: "nav-projects" },
            { id: "logistics", label: "Logistics360", path: "/logistics", icon: Truck, testid: "nav-logistics" },
            { id: "warehouse", label: "Warehouse360", path: "/warehouse", icon: Warehouse, testid: "nav-warehouse" },
            { id: "procurement", label: "Procurement360", path: "/procurement", icon: ShoppingCart, testid: "nav-procurement" },
            { id: "contractors", label: "Contractor360", path: "/contractors", icon: HardHat, testid: "nav-contractors" },
            { id: "suppliers", label: "Supplier Intelligence", path: "/suppliers", icon: ShoppingCart, testid: "nav-suppliers" },
            { id: "hr", label: "HR360", path: "/hr", icon: Users, testid: "nav-hr" },
        ],
    },
    {
        family: "governance",
        label: "Risk, Legal & Governance",
        accent: "red",
        items: [
            { id: "risk", label: "Risk360", path: "/risk", icon: AlertOctagon, testid: "nav-risk" },
            { id: "legal", label: "Legal360", path: "/legal", icon: Scale, testid: "nav-legal" },
        ],
    },
    {
        family: "knowledge",
        label: "Knowledge & Documents",
        accent: "purple",
        items: [
            { id: "knowledge", label: "Knowledge360", path: "/knowledge", icon: BookOpen, testid: "nav-knowledge" },
            { id: "documents", label: "Document360", path: "/documents", icon: FileText, testid: "nav-documents" },
        ],
    },
];

export const ALL_MODULES = MODULE_GROUPS.flatMap((g) => g.items);
export const findModule = (path) => ALL_MODULES.find((m) => m.path === path);

export const FUTURE_MODULES = [
    "HR360", "Sustainability360", "Reliability360", "Value Realisation Centre",
    "Real 3D Digital Twin", "Integration Hub Connectors",
];
